document.addEventListener('click', (event) => {
  const closeButton = event.target.closest?.('[data-dam-menu-close]');
  if (closeButton) closeButton.closest('.dam-mobile-menu')?.removeAttribute('open');
  document.querySelectorAll('.dam-mega[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});

document.addEventListener('keyup', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.dam-mega[open], .dam-mobile-menu[open]').forEach((menu) => menu.removeAttribute('open'));
});
